<template>
  <div class="page-inner r" style="min-height: 100vh;">
    <div class="page-title">
      <h3>{{ $t("message.Статистика_Лог_запросов") }}</h3>
      <div class="page-breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">{{ $t("message.Главная") }}</router-link>
          </li>
          <li class="active breadcrumb-item">Log Requests</li>
        </ol>
      </div>
    </div>
    <div id="main-wrapper" v-if="!hasReadPermissions">
      {{ $t("message.Нет_прав_доступа_на_чтение") }}
    </div>
    <div id="main-wrapper" v-if="hasReadPermissions">
      <b-row>
        <b-col class="col-1">
          <b-form-input
            v-model="login_id"
            type="text"
            placeholder="Enter login"
          ></b-form-input>
        </b-col>
        <b-col class="col-1">
          <b-button
            :variant="'success'"
            class="mb-1 float-left"
            @click="searchLogRequests()"
            >Search</b-button
          >
        </b-col>
      </b-row>

      <b-table
        id="device-table"
        :busy.sync="isBusy"
        :items="dataProvider"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
      >
        <template slot="login" slot-scope="row">
          {{ row.item.login }}<br />
        </template>
        <template slot="created_at" slot-scope="row">
          {{ row.item.created_at }}<br />
        </template>
        <template slot="remote_ip" slot-scope="row">
          {{ row.item.remote_ip }}<br />
        </template>
        <template slot="channel_id" slot-scope="row">
          {{ row.item.channel_id }}<br />
        </template>
        <template slot="channel_name" slot-scope="row">
          {{ row.item.channel_name }}<br />
        </template>
        <template slot="device" slot-scope="row">
          {{ row.item.device }}<br />
        </template>
        <template slot="device_model" slot-scope="row">
          {{ row.item.device_model }}<br />
        </template>
        <template slot="device_os_version" slot-scope="row">
          {{ row.item.device_os_version }}<br />
        </template>
        <template slot="device_app_version" slot-scope="row">
          {{ row.item.device_app_version }}<br />
        </template>
      </b-table>
      <b-pagination
        :total-rows="totalRows"
        :per-page="perPage"
        v-model="currentPage"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  name: "LogRequests",
  data() {
    return {
      isBusy: false,
      fields: [
        { key: "login", label: "Login", sortable: false },
        {
          key: "created_at",
          label: "Created at",
          sortable: false
        },
        {
          key: "remote_ip",
          label: "Remote IP",
          sortable: false
        },
        {
          key: "user_agent",
          label: "User Agent",
          sortable: false
        },
        {
          key: "content_type",
          label: "Content Type",
          sortable: false
        },
        {
          key: "channel_id",
          label: "Channel ID",
          sortable: false
        },
        {
          key: "channel_name",
          label: "Channel Name",
          sortable: false
        },
        {
          key: "device",
          label: "Device",
          sortable: false
        },
        {
          key: "device_model",
          label: "Model",
          sortable: false
        },
        {
          key: "device_os_version",
          label: "OS version",
          sortable: false
        },
        {
          key: "device_app_version",
          label: "App version",
          sortable: false
        }
      ],
      perPage: 10,
      currentPage: 1,
      totalRows: 0,
      login_id: ""
    };
  },
  computed: {
    hasReadPermissions: function() {
      return !!this.$storage
        .get("current_user")
        .permissions.filter(
          value =>
            value == "statistics:fully_manage" ||
            value == "statistics:logrequests_fully_manage"
        ).length;
    }
  },
  methods: {
    created() {},
    dataProvider(ctx) {
      // Here we don't set isBusy prop, so busy state will be handled by table itself
      // this.isBusy = true
      // console.log(ctx);
      let promise = this.$noname.get("logrequests", {
        params: {
          currentPage: ctx.currentPage,
          perPage: ctx.perPage,
          login: this.login_id
        }
      });

      return promise
        .then(data => {
          const items = data.data.items;
          this.totalRows = data.data.total;
          // Here we could override the busy state, setting isBusy to false
          // this.isBusy = false
          return items;
        })
        .catch(this.$noname.HandleError);
    },
    searchLogRequests(item, index, button) {
      this.$root.$emit("bv::refresh::table", "device-table");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modules/LogRequests.vue